export const SilaeSynchronizationStatusArray = [
  'all_status',
  'completed',
  'failed',
  'processing',
  'unsynchronized'
] as const

export type SilaeSynchronizationStatus =
  (typeof SilaeSynchronizationStatusArray)[number]

export type SilaeMetaStatusCount = {
  [Key in Exclude<SilaeSynchronizationStatus, 'processing'>]: number
}

export const SilaeSynchronizationFieldNameArray = [
  'gender',
  'firstname',
  'lastname',
  'birth_name',
  'citizenship',
  'birth_date',
  'birth_country',
  'birth_department_code',
  'birth_place',
  'family_situation',
  'seniority',
  'work_permit_type',
  'work_permit_number',
  'work_permit_start_date',
  'work_permit_expiration_date',
  'zip',
  'country_of_residence',
  'social_security_number',
  'employee_id',
  'email',
  'mobile_phone',
  'fixed_phone',
  'street_address',
  'complementary_street_address',
  'city',
  'iban',
  'has_no_health_plan',
  'health_plan_reason',
  'health_plan_reason_end_date',
  'bic',
  'emergency_contact_mobile_phone',
  'emergency_contact_fixed_phone'
] as const

export type SilaeSynchronizationFieldName =
  (typeof SilaeSynchronizationFieldNameArray)[number]

export type SilaeMemberSchema = {
  id: number
  employee_id: string
  error: { code: any; message: string }
  firstname: string
  lastname: string
  silae_case_number: number
  silae_status_message: string
  silae_synchronization_status: SilaeSynchronizationStatus
}

export type SilaeConfigurationSchema = {
  ready_to_use: boolean
  first_synchronization: boolean
}

export type SilaeRecordSchema = {
  numero: string
  raisonSociale: string
  siret: string
  groupe: string
}

export type SilaeConfigurationListRecordSchema = SilaeRecordSchema[]

export type SilaeAddonSchema = {
  name: string
  price: string
}

export type SilaeCredentialSchema = {
  identifier: string
  public_key: string
  expired: boolean
}

export type SilaeLocationsSchema = {
  id: number
  name: string
  case_number: string
}
